import { renderTrangThai, renderTuLieuHinhAnhVideo } from "src/util/Commom";

const ThongKeChiTietTable = ({ dataTable }: any) => {
  const styleCenterMiddle: any = {
    border: "1px solid #ccc",
    textAlign: "center",
    verticalAlign: "middle",
    width: "50px",
    height: "50px"
  };

  const styleLeftMiddle: any = {
    border: "1px solid #ccc",
    textAlign: "left",
    verticalAlign: "middle",
    height: "50px"
  };

  return (
    <div style={{ display: "block", overflowX: "auto" }}>
      <table
        border={0}
        cellSpacing={0}
        className="table-thongke"
        style={{ width: "100%", fontSize: "13px", fontFamily: "Arial" }}
      >
        <thead>
          <tr className="noBorder" hidden>
            <td
              align="center"
              colSpan={6}
              style={{
                height: 50,
                textAlign: "center",
                verticalAlign: "middle"
              }}
            >
              <b>THỐNG KÊ TỔNG HỢP CHI TIẾT THEO NHÓM TƯ LIỆU</b>
            </td>
          </tr>
          <tr>
            <td style={{ ...styleCenterMiddle }}>
              <b>STT</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 300 }}>
              <b>Tên tài liệu</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 150 }}>
              <b>Nhóm tài liệu</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 150 }}>
              <b>Phân loại</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 150 }}>
              <b>Người đăng</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 150 }}>
              <b>Tên tác giả</b>
            </td>
            <td style={{ ...styleLeftMiddle, width: 150 }}>
              <b>Trạng thái</b>
            </td>
          </tr>
        </thead>
        <tbody>
          {dataTable &&
            dataTable.map((item: any, index: number) => (
              <tr key={index + 1}>
                <td style={{ ...styleCenterMiddle }}>{index + 1}</td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {item.tenTuLieu}
                </td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {item.nhomTuLieu.tenNhomTuLieu}
                </td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {renderTuLieuHinhAnhVideo(item)}
                </td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {item.tenNguoiDang}
                </td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {item.tacGia}
                </td>
                <td style={{ ...styleLeftMiddle, width: 150 }}>
                  {renderTrangThai(item.trangThai)}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ThongKeChiTietTable;
